import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import styled from 'styled-components';
import { TypographyContainer } from '@/components/Typography/styles';
import { ellipsis } from '@/styles/common';
import { media } from '@/styles/responsive';

export const AcceptedAgreementDetailsWrapper = styled.div`
  ${flex()};
  flex: 1;
  background-color: ${COLORS.grey[150]};
  border-radius: 14px;
  border: 1px solid ${COLORS.grey[300]};
  padding: 12px 20px;
  column-gap: 20px;

  ${media.mobile`
    width: 100%;
    ${flex({ flexDirection: 'column' })};
    row-gap: 8px  
  `}
`;

export const Details = styled.div`
  ${flex({ flexDirection: 'column' })};
  gap: 6px 4px;
  flex-basis: 50%;
`;

export const Divider = styled.div`
  height: inherit;
  border: 1px dashed ${COLORS.grey[400]};
`;

export const DetailsValue = styled(TypographyContainer)`
  ${ellipsis};
  max-width: 200px;
  width: 100%;
`;
